// import YwSpace from "./YwSpace1.vue";
import { Space } from "ant-design-vue";
const { ...other } = Space;

const YwSpace = {
  ...other,
  name: "YwSpace",
  // ...YwSpace,
};
YwSpace.install = function (Vue) {
  Vue.component(YwSpace.name, YwSpace);
};
export default YwSpace;

